// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file companycatalog/v1/company_catalog.proto (package companycatalog.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file companycatalog/v1/company_catalog.proto.
 */
export const file_companycatalog_v1_company_catalog: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message companycatalog.v1.ExternalId
 */
export type ExternalId = Message<"companycatalog.v1.ExternalId"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: companycatalog.v1.Platform platform = 2;
   */
  platform: Platform;
};

/**
 * Describes the message companycatalog.v1.ExternalId.
 * Use `create(ExternalIdSchema)` to create a new message.
 */
export const ExternalIdSchema: GenMessage<ExternalId> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 0);

/**
 * @generated from message companycatalog.v1.GetCompanyRequest
 */
export type GetCompanyRequest = Message<"companycatalog.v1.GetCompanyRequest"> & {
  /**
   * @generated from field: optional companycatalog.v1.ExternalId external_id = 1;
   */
  externalId?: ExternalId;

  /**
   * @generated from field: optional string website = 2;
   */
  website?: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool is_manual = 4;
   */
  isManual: boolean;

  /**
   * @generated from field: bool allow_create_unverified = 5;
   */
  allowCreateUnverified: boolean;
};

/**
 * Describes the message companycatalog.v1.GetCompanyRequest.
 * Use `create(GetCompanyRequestSchema)` to create a new message.
 */
export const GetCompanyRequestSchema: GenMessage<GetCompanyRequest> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 1);

/**
 * @generated from message companycatalog.v1.GetCompanyResponse
 */
export type GetCompanyResponse = Message<"companycatalog.v1.GetCompanyResponse"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;
};

/**
 * Describes the message companycatalog.v1.GetCompanyResponse.
 * Use `create(GetCompanyResponseSchema)` to create a new message.
 */
export const GetCompanyResponseSchema: GenMessage<GetCompanyResponse> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 2);

/**
 * @generated from message companycatalog.v1.GetSolutionRequest
 */
export type GetSolutionRequest = Message<"companycatalog.v1.GetSolutionRequest"> & {
  /**
   * @generated from field: optional companycatalog.v1.ExternalId external_id = 1;
   */
  externalId?: ExternalId;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string website = 3;
   */
  website?: string;

  /**
   * @generated from field: optional string vendor_name = 4;
   */
  vendorName?: string;
};

/**
 * Describes the message companycatalog.v1.GetSolutionRequest.
 * Use `create(GetSolutionRequestSchema)` to create a new message.
 */
export const GetSolutionRequestSchema: GenMessage<GetSolutionRequest> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 3);

/**
 * @generated from message companycatalog.v1.GetSolutionResponse
 */
export type GetSolutionResponse = Message<"companycatalog.v1.GetSolutionResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message companycatalog.v1.GetSolutionResponse.
 * Use `create(GetSolutionResponseSchema)` to create a new message.
 */
export const GetSolutionResponseSchema: GenMessage<GetSolutionResponse> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 4);

/**
 * @generated from message companycatalog.v1.LinkNewSolutionToCompanyRequest
 */
export type LinkNewSolutionToCompanyRequest = Message<"companycatalog.v1.LinkNewSolutionToCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string solution_id = 2;
   */
  solutionId: string;

  /**
   * @generated from field: repeated companycatalog.v1.Platform platforms = 3;
   */
  platforms: Platform[];
};

/**
 * Describes the message companycatalog.v1.LinkNewSolutionToCompanyRequest.
 * Use `create(LinkNewSolutionToCompanyRequestSchema)` to create a new message.
 */
export const LinkNewSolutionToCompanyRequestSchema: GenMessage<LinkNewSolutionToCompanyRequest> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 5);

/**
 * @generated from message companycatalog.v1.LinkNewSolutionToCompanyResponse
 */
export type LinkNewSolutionToCompanyResponse = Message<"companycatalog.v1.LinkNewSolutionToCompanyResponse"> & {
  /**
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;
};

/**
 * Describes the message companycatalog.v1.LinkNewSolutionToCompanyResponse.
 * Use `create(LinkNewSolutionToCompanyResponseSchema)` to create a new message.
 */
export const LinkNewSolutionToCompanyResponseSchema: GenMessage<LinkNewSolutionToCompanyResponse> = /*@__PURE__*/
  messageDesc(file_companycatalog_v1_company_catalog, 6);

/**
 * @generated from enum companycatalog.v1.Platform
 */
export enum Platform {
  /**
   * @generated from enum value: PLATFORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLATFORM_GWS = 1;
   */
  GWS = 1,

  /**
   * @generated from enum value: PLATFORM_MSGRAPH = 2;
   */
  MSGRAPH = 2,

  /**
   * created by internal team
   *
   * @generated from enum value: PLATFORM_MANUAL = 3;
   */
  MANUAL = 3,

  /**
   * @generated from enum value: PLATFORM_WIZ = 4;
   */
  WIZ = 4,

  /**
   * @generated from enum value: PLATFORM_OKTA = 5;
   */
  OKTA = 5,

  /**
   * @generated from enum value: PLATFORM_NETSKOPE = 6;
   */
  NETSKOPE = 6,

  /**
   * @generated from enum value: PLATFORM_ZIPHQ = 7;
   */
  ZIPHQ = 7,

  /**
   * @generated from enum value: PLATFORM_GRAPHITECONNECT = 8;
   */
  GRAPHITECONNECT = 8,

  /**
   * @generated from enum value: PLATFORM_VENDR = 9;
   */
  VENDR = 9,

  /**
   * @generated from enum value: PLATFORM_LOGICMANAGER = 10;
   */
  LOGICMANAGER = 10,

  /**
   * @generated from enum value: PLATFORM_WEBHOOK = 11;
   */
  WEBHOOK = 11,

  /**
   * @generated from enum value: PLATFORM_PDL = 12;
   */
  PDL = 12,

  /**
   * @generated from enum value: PLATFORM_INTERNAL = 13;
   */
  INTERNAL = 13,

  /**
   * @generated from enum value: PLATFORM_ONETRUST = 15;
   */
  ONETRUST = 15,

  /**
   * @generated from enum value: PLATFORM_ASANA = 16;
   */
  ASANA = 16,

  /**
   * @generated from enum value: PLATFORM_RAMP = 17;
   */
  RAMP = 17,

  /**
   * @generated from enum value: PLATFORM_CROWDSTRIKE = 18;
   */
  CROWDSTRIKE = 18,
}

/**
 * Describes the enum companycatalog.v1.Platform.
 */
export const PlatformSchema: GenEnum<Platform> = /*@__PURE__*/
  enumDesc(file_companycatalog_v1_company_catalog, 0);

/**
 * @generated from service companycatalog.v1.CompanyCatalogService
 */
export const CompanyCatalogService: GenService<{
  /**
   * @generated from rpc companycatalog.v1.CompanyCatalogService.GetCompany
   */
  getCompany: {
    methodKind: "unary";
    input: typeof GetCompanyRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * @generated from rpc companycatalog.v1.CompanyCatalogService.GetSolution
   */
  getSolution: {
    methodKind: "unary";
    input: typeof GetSolutionRequestSchema;
    output: typeof GetSolutionResponseSchema;
  },
  /**
   * @generated from rpc companycatalog.v1.CompanyCatalogService.LinkNewSolutionToCompany
   */
  linkNewSolutionToCompany: {
    methodKind: "unary";
    input: typeof LinkNewSolutionToCompanyRequestSchema;
    output: typeof LinkNewSolutionToCompanyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_companycatalog_v1_company_catalog, 0);

